module.exports = __webpack_public_path__ + "static/img/t.28d03d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mother/t.png
// module id = o8di
// module chunks = 1